interface StatCardProps {
  number: string
  label: string
  index: number
}

export default function StatCard({ number, label, index }: StatCardProps) {
  return (
    <div className={`reveal stagger-${index + 1} text-center py-8 border-t border-border`}>
      <div className="text-5xl md:text-6xl font-bold tracking-tight mb-2 text-primary neon-glow">
        {number}
      </div>
      <p className="text-[10px] uppercase tracking-ultra-wide text-muted-foreground">
        {label}
      </p>
    </div>
  )
}